<span>{{ text }}</span>
<mat-icon color="primary" (click)="copy()"> content_copy </mat-icon>
